import axios from 'axios'
// import baseUrl from './base-url'
// const baseUrl = 'https://' + (process.env.NODE_ENV === 'dev' ? 'dev.' : '') + 'doctorboxapi.com/chart/'
const baseUrl = 'http://localhost:8000'

export default function({ state }, pdf) {

    return axios.post(baseUrl, pdf, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: false
        })
        .then((response) => {
            return 'data:application/pdf;base64,' + encode(new Uint8Array(response.data))
        })
        .catch((error) => {
            // console.log('post error', error)
            // console.log('error', JSON.stringify(error.response.data, null, 4))
            throw error.response.data
        })
}

// Encode Uint8Array
function encode(input) {
    var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    while (i < input.length) {
        chr1 = input[i++];
        chr2 = i < input.length ? input[i++] : Number.NaN;
        chr3 = i < input.length ? input[i++] : Number.NaN;

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }
        output += keyStr.charAt(enc1) + keyStr.charAt(enc2) +
                  keyStr.charAt(enc3) + keyStr.charAt(enc4);
    }
    return output;
}
